import React, { useState, useContext, useEffect } from 'react'
import { Form, Input, Button, Row, message } from 'antd'
import { Context } from '../../context'
import src from '../../context/cacheApp'
import env from '../../api/env'
import CryptoAES from 'crypto-js/aes'
import CryptoJSAesJson from '../../config/cryptojs-aes-format'
import loginSrc from './loginSrc'
import DBService from '../../utils/DBService'
import Swal from 'sweetalert2'
import platformSettingSrc from '../personalizacion/platformSettingSrc'

function Login() {
  const [_, dispatch] = useContext(Context) // eslint-disable-line
  const [loading, setLoading] = useState(false)
  const [loginLogo, setLoginLogo] = useState('')

  useEffect(() => {
    platformSettingSrc.getPlatformSettingsPublic().then(response => {
      if (response?.login_logo) setLoginLogo(response.login_logo)
    })
  }, [])

  const handleLoginSuccess = authData => {
    src.sessionApp(authData, 'setter')
    dispatch({
      type: 'AUTH FETCHED',
      payload: authData,
    })
    DBService.deleteAll('auth')
    DBService.addOne(authData, 'auth')
  }

  const handleSubmit = async values => {
    setLoading(true)

    // 🔐 Preparamos los encriptados UNA sola vez para reusarlos
    const usernameE = CryptoAES.encrypt(
      JSON.stringify(values.username),
      env.passphrase,
      { format: CryptoJSAesJson }
    ).toString()

    const passwordE = CryptoAES.encrypt(
      JSON.stringify(values.password),
      env.passphrase,
      { format: CryptoJSAesJson }
    ).toString()

    try {
      // Primer intento
      const auth = await loginSrc.authLogin(usernameE, passwordE)

      if (!auth?.data) {
        message.error(auth?.message || 'Ocurrió un error')
        return
      }

      handleLoginSuccess(auth.data)
    } catch (err) {
      const status = err?.response?.status

      if (status === 401) {
        message.error('Usuario o contraseña incorrectos')
      } else if (status === 409) {
        // 👉 Aquí entra la sesión activa
        const result = await Swal.fire({
          title: 'Sesión activa',
          text: 'El usuario tiene una sesión activa. ¿Desea cerrar la otra sesión?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, cerrar sesión',
          cancelButtonText: 'Cancelar',
          allowOutsideClick: false,
          allowEscapeKey: false,
        })

        if (result.isConfirmed) {
          try {
            // 1️⃣ Pedimos al backend que cierre TODAS las sesiones previas de ese usuario
            await loginSrc.forceLogout(usernameE, passwordE)

            // 2️⃣ Reintentamos login
            const retryAuth = await loginSrc.authLogin(usernameE, passwordE)

            if (!retryAuth?.data) {
              message.error(retryAuth?.message || 'No se pudo iniciar sesión después de cerrar la otra sesión')
              return
            }

            handleLoginSuccess(retryAuth.data)
            message.success('Sesiones anteriores cerradas. Inicio de sesión exitoso.')
          } catch (e) {
            console.error(e)
            message.error('No se pudo cerrar la sesión activa. Intenta de nuevo.')
          }
        } else {
          message.info('La sesión anterior sigue activa.')
        }
      } else {
        console.error(err)
        message.error('Ocurrió un error inesperado al iniciar sesión')
      }
    } finally {
      setLoading(false)
    }
  }

  const onFinishFailed = errorInfo => {
    errorInfo.errorFields.map(error => message.error(error.errors))
  }

  return (
    <Row type="flex" justify="center" align="middle" className={'login-row-container'}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '100%',
        }}
      >
        <img src={loginLogo || 'tendero-logo-lg.png'} className={'login-logo-lg'} alt={'moocho'} />

        <div className={'login-container'}>
          <Form
            name="login-form"
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            style={{ width: '400px', maxWidth: '90%' }}
            labelAlign={'left'}
            labelCol={{ xs: 24, sm: 24, md: 24, lg: 24 }}
            wrapperCol={{ xs: 24, sm: 24, md: 24, lg: 24 }}
            colon={false}
          >
            <Form.Item
              style={{ textAlign: 'left' }}
              label="Usuario"
              name="username"
              rules={[
                {
                  message: 'Ingresa un username valido',
                  type: 'string',
                },
              ]}
            >
              <Input placeholder={'Escribe tu usuario'} size={'large'} />
            </Form.Item>
            <Form.Item style={{ textAlign: 'left' }} label="Contraseña" name="password">
              <Input.Password placeholder={'Escribe tu contraseña'} size={'large'} />
            </Form.Item>

            <div className={'login-button-container'} style={{ paddingBottom: '25px' }}>
              <Button type={'link'} className={'login-btn-link'} style={{ cursor: 'default' }}>
                <div>¿No recuerdas tu contraseña?</div>
                <div>Contacta con el administrador de tu cuenta</div>
              </Button>
            </div>

            <div className={'login-button-container'}>
              <Form.Item>
                <Button
                  style={{ paddingLeft: '3em', paddingRight: '3em' }}
                  className="bottom-login login-btn"
                  disabled={loading}
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                >
                  Iniciar sesion
                </Button>
              </Form.Item>
              <span className={'login-btn-link title-space-top'}>
                    V - 1.0 Señor Tendero
              </span>
            </div>
          </Form>
        </div>
      </div>
    </Row>
  )
}
export default Login
